import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Alert, Badge, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import moment from 'moment';



export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue }) {

    const userInfo = LoginManager.getUserInfo();
    var location = window.location;

    const [voyageMessage, setVoyageMessage] = useState('');
    const [bicValidatorMessage, setBicValidatorMessage] = useState('');
    const [bicStatus, setBicStatus] = useState('success');
    const [userGroup, setUserGroup] = useState(null);


    async function checkReferenceNumber() {
        var sorting = {
            'field': 'date',
            'order': 'desc'
        }
        var constraints = [
            {
                fieldName: 'riferimento_merce',
                type: 'value',
                value: data.riferimento_merce
            },
            {
                fieldName: 'ciclo',
                type: 'value',
                value: data.ciclo ? data.ciclo.value : 'IMPORT'
            },
            {
                fieldName: 'voyageDateTime',
                type: 'greater',
                value: (moment(data.voyageDateTime, 'YYYY-MM-DD HH:mm').add(-5, 'days')).format('YYYY-MM-DD HH:mm')
            }
        ]
        var resp = await DataManager.searchItems('voyage', 1, 1, sorting, '', [], constraints)
        if (resp.body && resp.body.length) {
            console.warn(resp)
            setVoyageMessage('Esiste già un viaggio con il seguente riferimento merce: ' + data.riferimento_merce + ' con ciclo: ' + resp.body[0].ciclo.value + ' in data: ' + resp.body[0].voyageDateTime)
        }
        else {
            setVoyageMessage('')
        }
    }

    async function checkContainerBic(bic) {
        if (bic.length < 10) {
            setBicValidatorMessage('Il codice contenitore NON è valido.')
            setBicStatus('danger')
        }
        else {
            const code = bic.slice(0, 4); // First 4 chars
            const start = bic.slice(4, 10); // Chars from 5 to 10
            const check = bic.slice(10, 11);

            var body = {
                bic: bic,
                code: code,
                start: start,
                check: check
            }
            var response = await ApiManager.sendAuthenticatedRequest('/custom/check_bic', body);
            console.log('check_bic', response);
            if (response.success === 1) {
                if (response.validator === true) {
                    setBicValidatorMessage('Il codice contenitore è valido.')
                    setBicStatus('success')
                }
                else {
                    setBicValidatorMessage('Il codice contenitore NON è valido.')
                    setBicStatus('danger')
                }
            }
        }
    }

    useEffect(() => {
        if (entity === 'voyage') {
            if (!data.voyageDateTime) {
                const today = moment().format('YYYY-MM-DDTHH:mm');
                setDataKeyValue('voyageDateTime', today)
            }
            if (userInfo.level === 1) {
                autoSetOperatore(userInfo.idUserGroup)
            }

            if (data.riferimento_merce && data.riferimento_merce.length > 10) {
                const appContainer = document.getElementById("app-container");
                const dataPage = appContainer.getAttribute("data-page");
                if (dataPage === '/entity/voyage/add') {
                    //solo in inserimento
                    checkReferenceNumber()
                }
            }
            else {
                setVoyageMessage('')
            }

            if (data.tipo_merce && (data.tipo_merce.value === 'CONTAINER' || data.tipo_merce.value === 'TRENO')) {
                var newString = (data.riferimento_merce.replace(/[^a-zA-Z0-9]/g, "")).toUpperCase().substring(0, 11)
                if (data.riferimento_merce !== newString) {
                    setDataKeyValue('riferimento_merce', newString)
                }

                if (data.riferimento_merce.length > 4) {
                    checkContainerBic(data.riferimento_merce)
                }
                else {
                    setBicValidatorMessage('')
                }
            }
            else {
                setBicValidatorMessage('')
            }
        }
    }, [data]);


    async function autoSetOperatore(idGroup) {
        if (userGroup) {
            var idOperatore = userGroup.idOperatore.id
            if (data.idOperatore && data.idOperatore.id !== idOperatore) {
                setDataKeyValue('idOperatore', { id: idOperatore, denominazione: userGroup.idOperatore.denominazione })
            }
            if (data.idOperatore === "") {
                setDataKeyValue('idOperatore', { id: idOperatore, denominazione: userGroup.idOperatore.denominazione })
            }

            /** solo per sts e p&a */
            if ((idOperatore === 12 || idOperatore === 10) && !data.idTerminal) {
                setDataKeyValue('idTerminal', { id: 14, name: 'PSAGP (PSA GENOVA PRA)' })
            }
        }
        else {
            let g = await DataManager.getItem('user_group', idGroup)
            if (g.success === 1) {
                if (g.body[0] && g.body[0].idOperatore) {
                    setUserGroup(g.body[0])
                    var idOperatore = g.body[0].idOperatore.id
                    if (data.idOperatore && data.idOperatore.id !== idOperatore) {
                        setDataKeyValue('idOperatore', { id: idOperatore, denominazione: g.body[0].idOperatore.denominazione })
                    }
                    if (data.idOperatore === "") {
                        setDataKeyValue('idOperatore', { id: idOperatore, denominazione: g.body[0].idOperatore.denominazione })
                    }

                    /** solo per sts e p&a */
                    if ((idOperatore === 12 || idOperatore === 10) && !data.idTerminal) {
                        setDataKeyValue('idTerminal', { id: 14, name: 'PSAGP (PSA GENOVA PRA)' })
                    }
                }
            }
        }
    }



    useEffect(() => {
        if(location.pathname === "/entity/voyage/edit" && parseInt(userInfo.level) === 0){
            var a = document.getElementById('voyage_field_tipologia_contenitore');
            a.style.display = 'block'
        }
    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'voyage': return (
                            <>
                                {voyageMessage && voyageMessage.length ? (
                                    <Container fluid>
                                        <Alert className='small' variant='warning'>
                                            <h5>Attenzione</h5>
                                            {voyageMessage}
                                            <br />
                                            Questo è solamente un avviso. Puoi comunque inserire il viaggio.
                                        </Alert>
                                    </Container>
                                ) : (
                                    <></>
                                )}

                                {bicValidatorMessage && bicValidatorMessage.length ? (
                                    <Container fluid>
                                        <Alert className='small' variant={bicStatus}>
                                            <h5>Riferimento merce</h5>
                                            {bicValidatorMessage}
                                        </Alert>
                                    </Container>
                                ) : (
                                    <></>
                                )}
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};